/* eslint-disable no-restricted-globals */
import React, { useRef, useEffect, useCallback } from 'react';
import { Tab } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import PropTypes from 'prop-types';

import LinksList from '../LinksList';

import { useOnLoadImages } from '../../../../utils/hooks/useOnLoadImages';

const Item = ({ guides, onSelectKey }) => {
  const location = useLocation();
  const history = useHistory();

  const contentRef = useRef(null);

  const imagesLoaded = useOnLoadImages(contentRef);

  const onClickContent = (event) => {
    if (event?.target?.nodeName === 'A') {
      const type = event.target.getAttribute('data-type');
      if (type === 'internal') {
        event.preventDefault();
        onSelectKey(event.target.getAttribute('href'));
      }
      if (type === 'anchor') {
        event.preventDefault();
        event.stopPropagation();
      }
      if (type === 'anchor-link') {
        event.preventDefault();
        const href = event.target?.getAttribute('href');
        const [articleId, anchor] = href?.split('_');
        if (!isNaN(articleId) && !isNaN(anchor)) {
          const findedCategory = guides?.find((item) => item?.articles?.find((art) => art.id === Number(articleId)));
          if (findedCategory) {
            const findedArticle = findedCategory?.articles?.find((art) => art.id === Number(articleId));
            if (findedArticle) {
              const findedAnchor = findedArticle.content?.match(new RegExp(`href="${href}"`, 'g'));
              if (findedAnchor) {
                onSelectKey(`${findedCategory.category_name}.${findedArticle.title}`);
                history.replace({ pathname: location.pathname, search: `?anchor=${href}` });
              }
            }
          }
        }
      }
    }
  };

  const relatedArticles = (articles, currentArticle) => articles.filter((art) => art.title !== currentArticle.title && art.type !== 'Section');

  const onEnteredTabPane = useCallback(() => {
    const search = qs.parse(location.search.slice(1));
    const anchorElement = document?.querySelector(`[data-type="anchor"][href="${search?.anchor}"]`);
    if (anchorElement) {
      setTimeout(() => {
        anchorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        history.replace({ pathname: location.pathname });
      }, 300);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesLoaded, location.search]);

  useEffect(() => {
    if (imagesLoaded) {
      onEnteredTabPane();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesLoaded]);

  return (
    <>
      {guides?.map((item) => item?.articles?.map((article, index) => {
        const related = relatedArticles(item.articles, article);

        return (
          <Tab.Pane
            onEntered={() => onEnteredTabPane()}
            onExit={() => window.scrollTo(0, 0)}
            eventKey={article?.type === 'Article' ? `${item.category_name}.${article.title}` : null}
            key={index}
          >
            <div className="guides__article-header">
              <div className="title">{article.title}</div>
            </div>

            <div
              ref={contentRef}
              className="guides__article-content"
              onClick={onClickContent}
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            {related && related?.length ? (
              <div className="guides__article-related">
                <div className="guides__article-related--label">Related articles</div>
                <LinksList
                  type="categories"
                  items={related}
                  fieldName="title"
                  onClick={(tabData) => onSelectKey(`${item.category_name}.${tabData.title}`)}
                />
              </div>
            ) : null}
          </Tab.Pane>
        );
      }))}
    </>
  );
};

Item.propTypes = {
  guides: PropTypes.array,
  onSelectKey: PropTypes.func,
};

export default Item;
